export enum EExportFormat {
  human = 'human',
  machine = 'machine'
}
